// extracted by mini-css-extract-plugin
module.exports = {"list":"list_list__zCLOG","item":"list_item__QVzFu","with-custom-icons":"list_with-custom-icons__6OtjZ","item-with-icon":"list_item-with-icon__3G4TZ","icon":"list_icon__ZS1ah"};